/**
 * Fungsi untuk mengecek apakah sebuah string adalah email yang valid.
 * @param {string} email - teks yang ingin dicek
 * @returns {boolean} true jika valid, false jika tidak
 */
const isValidEmail = (email) => {
  const regex = /^(?!.*\.\.)[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]{0,63}[a-zA-Z0-9])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

export default isValidEmail